    <div class="modal-header flex-fill">
        <h3 class="modal-title d-flex justify-content-between" style="font-size: 18px; font-weight: 400;">Delete Metrics
        </h3>
        <button type="button" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail"
            (click)="CloseModal()">
            <svg class="icon-16">
                <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <div class="mx-6">
            <cxone-embedded-messages [messageType]="'system-warning'"  [messageData]="getLocalizationString('Metric_Deletion', 'Metric deletion may affect associated metrics and dashboards')" id="system-warning"> </cxone-embedded-messages>
            <div style="font-weight: bold; padding-top: 6px; padding-bottom: 6px;">
                <span cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Metric_Used">Metrics associated with</span><span>&nbsp;</span><span>{{SelectedMetric.Abreviation}}</span><span>:</span>
            </div>
            <div class="d-flex" style="height: 300px; padding-top: 10px; padding-bottom: 10px;">
                <ag-grid-angular [gridOptions]="gridOptions" [rowData]="metricList"
                    class="ag-theme-balham flex-fill grid-container" *ngIf="gridOptions !== undefined">
                </ag-grid-angular>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="cxone-btn btn-medium btn-primary" (click)="CloseModal()">Close</button>
    </div>
